import { RouteRecordRaw } from 'vue-router';
import { locations } from '@/shared/config/locations';

// Create the location routes using the dynamic route parameter
export const locationRoutes: RouteRecordRaw[] = [
  {
    path: 'locations/:city',
    name: 'location-detail',
    component: () => import('@/features/locations/LocationPage.vue'),
    // Add props to pass the city parameter directly as a prop for more flexibility
    props: true
  }
]; 